import * as React from 'react'
import * as styles from './toggle.component.styl'
import cx from 'classnames'
import Tooltip from '../tooltip'

export interface Props {
  on: boolean
  onClick?: () => void
  disabled?: boolean
  tooltip?: string
  className?: string
  role?: string
}

const Switch: React.FC<Props> = ({
  on,
  role,
  onClick,
  disabled = false,
  className,
  tooltip
}: Props) => (
  <Tooltip description={tooltip} placement="top">
    <div
      role={role}
      className={cx(styles.switch, className, {
        [styles.on]: on,
        [styles.disabled]: disabled
      })}
      onClick={() => {
        if (onClick) onClick()
      }}
    >
      <div className={styles.switchToggle} />
    </div>
  </Tooltip>
)

export default Switch
